// Node Module Imports
import React, { useEffect, useState } from 'react'

import { Link } from 'gatsby'
import { FaBars, FaPhone, FaSignInAlt, FaTimes } from 'react-icons/fa'
import { MdChat } from 'react-icons/md'
import { connect } from 'react-redux'
import styled from 'styled-components'

// Component Imports
import { colors, fontSize, space } from '../../style/design-system'
import personas from '../../utils/static-data/personas'
import UmaLogoRectangle from '../core/uma-logo-rect'
import { UnderlinedAGa } from '../elements/UnderlinedAGoogleAnalytics'
import NavPrimary from './NavPrimary'
import SearchBar from './SearchBar'

const NavMobile = ({ className, _r_persona }) => {
  const [mobileLinksVisible, setMobileLinksVisible] = useState(false)

  const personasThatCanRequestInfo = Object.keys(personas).filter(
    (persona) => personas[persona].cta === 'Get Started',
  )
  const canRequestInfo =
    personasThatCanRequestInfo.indexOf(_r_persona.name) !== -1

  useEffect(() => {
    const body = document.querySelector('body')
    mobileLinksVisible
      ? body.classList.add('prevent-scroll')
      : body.classList.remove('prevent-scroll')
  })

  const closeMobileNav = () => {
    setMobileLinksVisible(false)
  }

  const toggleMobileLinksVisible = () => {
    setMobileLinksVisible(!mobileLinksVisible)
  }

  return (
    <nav className={`${className} nav-mobile d-lg-none`}>
      <div className="top-line container-fluid">
        <div className="logo">
          <Link to="/" aria-label="Go to home page">
            <UmaLogoRectangle />
          </Link>
        </div>
        <div className="icons">
          <a
            href={`tel:${_r_persona.phoneNumber}`}
            aria-label="Call Ultimate Medical Academy">
            <FaPhone />
          </a>
          <button
            className="btn pointer no-outline"
            aria-label="Open mobile navigation"
            onClick={toggleMobileLinksVisible}
            type="button">
            {!mobileLinksVisible ? <FaBars /> : <FaTimes />}
          </button>
        </div>
      </div>
      <div
        className={`links container-fluid ${
          mobileLinksVisible ? 'expanded' : ''
        }`}>
        <div className="links-internal nowrap">
          <SearchBar className="mx-4 my-6" />
          <NavPrimary closeMobileNav={closeMobileNav} />
          <hr className="mx-4 my-6" />
          <UnderlinedAGa
            className="student-portal mx-4"
            color={colors.umaDarkBlue}
            gaLabel="TODO"
            href="/students/puma-den-login/">
            <FaSignInAlt />
            &nbsp; Student Portal
          </UnderlinedAGa>
        </div>
      </div>
    </nav>
  )
}

const StyledNavMobile = styled(NavMobile)`
  display: block;
  position: fixed;
  width: 100%;
  top: 0;
  background-color: ${colors.umaUltimateLightGray};
  .top-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icons {
      .btn,
      a {
        border: none;
        background: transparent;
        padding: 0;
        margin-left: 1.125rem;
        &:first-child {
          margin-left: 0;
        }
      }
      svg {
        color: ${colors.umaDarkBlue};
        font-size: 1.875rem;
      }
    }
  }
  .links {
    position: fixed;
    height: 100vh;
    overflow: hidden;
    transition: all 0.3s ease;
    background: ${colors.dev.gray.h()};
    width: 0;
    padding: 0;
    &.expanded {
      width: 100vw;
      padding: 0 ${space.e} 25rem ${space.e};
    }
    [class^='SearchBar'] {
      width: 100%;
      background-color: #fff;
    }
    .links-internal {
      height: 100vh;
      overflow: auto;
      padding-bottom: 16rem;
    }
  }
  a {
    display: inline-block;
  }
  .logo {
    font-size: 0;
  }
  .student-portal {
    font-size: ${fontSize.h};
    font-family: Acumin-pro-condensed;
    font-weight: 700;
    svg {
      transform: translateY(-10%);
    }
  }
`

const mapStateToProps = (state) => ({
  _r_persona: state.persona,
})

export default connect(mapStateToProps)(StyledNavMobile)

// TODO: Use Aaron's icons instead of Font Awesome icons
